function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 11.102C11.9062 11.102 11.3583 11.3061 10.9292 11.6469L6.6125 8.58775C6.68478 8.19912 6.68478 7.80088 6.6125 7.41224L10.9292 4.35306C11.3583 4.69388 11.9062 4.89796 12.5 4.89796C13.8792 4.89796 15 3.8 15 2.44898C15 1.09796 13.8792 0 12.5 0C11.1208 0 10 1.09796 10 2.44898C10 2.68571 10.0333 2.91224 10.0979 3.12857L5.99792 6.03673C5.38958 5.24694 4.42292 4.73469 3.33333 4.73469C1.49167 4.73469 0 6.19592 0 8C0 9.80408 1.49167 11.2653 3.33333 11.2653C4.42292 11.2653 5.38958 10.7531 5.99792 9.96327L10.0979 12.8714C10.0333 13.0878 10 13.3163 10 13.551C10 14.902 11.1208 16 12.5 16C13.8792 16 15 14.902 15 13.551C15 12.2 13.8792 11.102 12.5 11.102ZM12.5 1.38776C13.0979 1.38776 13.5833 1.86327 13.5833 2.44898C13.5833 3.03469 13.0979 3.5102 12.5 3.5102C11.9021 3.5102 11.4167 3.03469 11.4167 2.44898C11.4167 1.86327 11.9021 1.38776 12.5 1.38776ZM3.33333 9.79592C2.32292 9.79592 1.5 8.9898 1.5 8C1.5 7.0102 2.32292 6.20408 3.33333 6.20408C4.34375 6.20408 5.16667 7.0102 5.16667 8C5.16667 8.9898 4.34375 9.79592 3.33333 9.79592ZM12.5 14.6122C11.9021 14.6122 11.4167 14.1367 11.4167 13.551C11.4167 12.9653 11.9021 12.4898 12.5 12.4898C13.0979 12.4898 13.5833 12.9653 13.5833 13.551C13.5833 14.1367 13.0979 14.6122 12.5 14.6122Z",
  fill: "#666666"
});
function SvgIconShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShare);
export default __webpack_public_path__ + "static/media/iconShare.5bed5740.svg";
export { ForwardRef as ReactComponent };